import React from "react";
import PageContainer from "@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "@jumbo/utils/IntlMessages";
import FormsContainer from "@jumbo/Dashboards/FormBuilder/FormsContainer";

const breadcrumbs = [
  { label: <IntlMessages id="sidebar.main" />, link: "/" },
  { label: <IntlMessages id="pages.forms" />, isActive: true },
];

export default function Forms() {
  return <PageContainer heading={<IntlMessages id="pages.forms" />} breadcrumbs={breadcrumbs}>
    <FormsContainer />
  </PageContainer>;
}
